import { render, staticRenderFns } from "./RegisterComponent.vue?vue&type=template&id=16006ff4&"
import script from "./RegisterComponent.vue?vue&type=script&lang=js&"
export * from "./RegisterComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports